<template>
  <section v-loading.fullscreen.lock="loading">
    <div class="term1">
      <div class="term1-top">
        <div class="term1-top-info">
          联系人:
          <el-input
            v-model="name"
            placeholder=""
            disabled
            @input="handleName(name)"
          />
        </div>
        <div class="term1-top-info">
          联系电话:
          <el-input
            v-model="phone"
            disabled
            placeholder=""
            maxlength="11"
            @input="handleNumber(phone)"
          />
        </div>
        <span @click="handlePre">上一章</span>
        <span @click="handleNext">下一章</span>
        <span @click="handleSave">保存</span>
        <span>获取上年数据</span>
        <span @click="handleClear">清空</span>
      </div>
      <div class="term1-content">
        <el-table
          :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
          :data="data"
          stripe
          border
          style="width: 100%"
        >
          <el-table-column prop="code" label="代码" width="90">
            <template slot-scope="scope">
              <span class="text-center">{{ scope.row.code }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" width="320" label="指标名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
              <el-tooltip
                v-if="scope.row.desc && scope.row.desc != ' '"
                effect="light"
                placement="left"
              >
                <div slot="content">
                  {{ scope.row.desc }}
                </div>
                <svg
                  t="1647934656452"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3085"
                  width="16"
                  height="16"
                  @click="handleOpen(scope.row.desc)"
                >
                  <path
                    d="M512 149.333333A362.666667 362.666667 0 1 1 149.333333 512 363.093333 363.093333 0 0 1 512 149.333333M512 85.333333a426.666667 426.666667 0 1 0 426.666667 426.666667A426.666667 426.666667 0 0 0 512 85.333333z"
                    fill="#2f82ff"
                    p-id="3086"
                  />
                  <path
                    d="M469.333333 672a31.573333 31.573333 0 0 1-22.613333-9.386667l-128-128a32 32 0 0 1 45.226667-45.226666L469.333333 594.773333l213.333334-213.333333A32 32 0 0 1 725.333333 426.666667l-234.666666 234.666666a31.573333 31.573333 0 0 1-21.333334 10.666667z"
                    fill="#2f82ff"
                    p-id="3087"
                  />
                </svg>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="uom" label="单位" width="90">
            <template slot-scope="scope">
              <span class="text-center">{{ scope.row.uom }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="value5" label="本年数值">
            <template slot-scope="scope" inline-template>
              <section v-if="scope.row.code == 221">
                <span class="text-center">{{ manager ? manager : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 231">
                <span class="text-center">{{ lab ? lab : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 232">
                <span class="text-center">{{ house ? house : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 24">
                <span class="text-center">{{ equip ? equip : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 241">
                <span class="text-center">{{ yiqi_yuanzhi ? yiqi_yuanzhi : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 242">
                <span class="text-center">{{ equip_yuanzhi ? equip_yuanzhi : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 243">
                <span class="text-center">{{ yiqi_average ? yiqi_average : scope.row.value5 }}</span>
              </section>
              <section v-else-if="scope.row.code == 244">
                <span class="text-center">{{ lab_price ? lab_price : scope.row.value5 }}</span>
              </section>
              <section
                v-else-if="scope.row.equipstandardopt.viewOnly[4] == false"
              >
                <el-select
                  v-if="scope.row.equipstandardopt.optional"
                  v-model="scope.row.value5"
                  placeholder="请选择"
                  @change="
                    handleValue(scope.row.value5, scope.$index, scope.row)
                  "
                >
                  <el-option
                    v-for="item in scope.row.equipstandardopt.optional"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value"
                  />
                </el-select>
                <el-input
                  v-else
                  v-model="scope.row.value5"
                  :disabled="
                    scope.row.equipstandardopt.readOnly[4] == true
                      ? true
                      : false
                  "
                  placeholder=""
                  @input="handleNumber(scope.row)"
                  @change="
                    handleValue(
                      scope.row.value5,
                      scope.$index,
                      scope.row,
                      scope
                    )
                  "
                />
              </section>
              <section v-else>
                <span class="text-center">—</span>
              </section>
            </template>
          </el-table-column>
          <el-table-column prop="value6" label="本年面积">
            <template slot-scope="scope" inline-template>
              <section v-if="scope.row.code == 231">
                <span class="text-center">{{ lab_area ? lab_area : scope.row.value6 }}</span>
              </section>
              <section v-else-if="scope.row.code == 232">
                <span class="text-center">{{ house_area ? house_area : scope.row.value6 }}</span>
              </section>
              <section v-else>
                <el-input
                  v-if="scope.row.equipstandardopt.viewOnly[5] == false"
                  v-model="scope.row.value6"
                  :disabled="
                    scope.row.equipstandardopt.readOnly[5] == true
                      ? true
                      : false
                  "
                  placeholder=""
                  @input="handleNumber(scope.row.value6)"
                  @change="
                    handleValue0(
                      scope.row.value6,
                      scope.$index,
                      scope.row,
                      scope
                    )
                  "
                />
                <span v-else class="text-center">—</span>
              </section>
            </template>
          </el-table-column>
          <el-table-column prop="logic" label="取值逻辑">
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.logic"
                effect="light"
                placement="top">
                <div slot="content">
                  {{ scope.row.logic }}
                </div>
                <span class="logic" @click="handleOpen(scope.row.logic)">{{
                  scope.row.logic
                }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </section>
</template>
<script>
import api from '@/api/app'
import mock from '@/utils/mock'
export default {
  name: 'ComTerm1',
  components: {},
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      loading: false,
      name: '',
      phone: '',
      statisticsInfo: mock.statistics.statistics.viewInfo,
      statisticsInit: mock.statistics.statistics.init,
      t: null,
      form: [],
      jsonForm: {},
      pushArr: true,
      other: {
        num1: null,
        num2: null,
        num3: null,
        num4: null,
        num5: null,
        num6: null,
        num7: null,
        num8: null,
        num9: null,
        num10: null,
        num11: null
      },
      manager: null,
      lab: null,
      lab_area: null,
      house: null,
      house_area: null,
      equip: null,
      yiqi_yuanzhi: null,
      equip_yuanzhi: null,
      yiqi_average: null,
      lab_price: null


    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.handleOthers()
    if (localStorage.getItem('form2')) {
      this.form = JSON.parse(localStorage.getItem('form2'))
    } else {
      this.form = this.data
    }
  },
  methods: {
    handleOthers() {
      var a = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num1,
        21,
        23,
        '2.1 教学仪器设备配备达标情况',
        '',
        '',
        {
          code: 21,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 23,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var b = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num2,
        22,
        31,
        '2.2 实验室管理人员情况',
        '',
        '',
        {
          code: 22,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 31,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var c = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num3,
        23,
        51,
        '2.3 实验室配备情况',
        '',
        '',
        {
          code: 23,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 51,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var d = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num4,
        233,
        70,
        '2.3.3 危险化学品专用储藏情况',
        '',
        '',
        {
          code: 233,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 70,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var e = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num5,
        234,
        73,
        '2.3.4 其他',
        '',
        '',
        {
          code: 234,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 73,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var f = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num6,
        25,
        103,
        '2.5 实验教学情况',
        '',
        '',
        {
          code: 25,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 103,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )

      var g = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num7,
        253,
        106,
        '2.5.3 小学科学',
        '',
        '',
        {
          code: 253,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 106,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var h = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num8,
        254,
        111,
        '2.5.4 初中物理',
        '',
        '',
        {
          code: 254,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 111,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var i = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num9,
        255,
        116,
        '2.5.5 初中化学',
        '',
        '',
        {
          code: 255,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 116,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
      var j = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num10,
        256,
        121,
        '2.5.6 初中生物',
        '',
        '',
        {
          code: 256,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 121,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )

      var k = this.handleValueModle(
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.other.num11,
        257,
        126,
        '2.5.7 劳动与技术',
        '',
        '',
        {
          code: 257,
          hisIdx: ['-1', '-1', '-1', '-1', '-1', '-1'],
          id: 126,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, true, true],
          year: 2022
        },
        ''
      )
    },
    compare(attr) {
      return function(a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val1 - val2
      }
    },
    arrayLookup(data, key, value, targetKey) {
      var targetValue = ''
      for (var i = 0; i < data.length; i++) {
        if (data[i][key] == value) {
          targetValue = data[i][targetKey]
          break
        }
      }
      return targetValue
    },
    handleValue0(x, y, z, a) {
      var isExit = false
      var obj = {}
      for (var i = 0; i < this.form.length; i++) {
        if (this.form[i].id == z.id) {
          this.form[i].value6 = z.value6
          isExit = true
          break
        }
      }
      if (!isExit) {
        this.form.push(obj)
      }
      var q = this.handleValueModle0(
        23101,
        23102,
        23103,
        23105,
        23106,
        23113,
        23104,
        0, 0, 0,
        this.lab_area,
        231,
        52,
        '2.3.1 实验室合计',
        '是指用于小学科学、中学物理、化学、生物等学科学生实验用教室，不包括仪器室、准备室等配套的辅助用房',
        '个、m²',
        {
          code: 231,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '6'],
          id: 52,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, false],
          year: 2022
        },
        '23101+23102+23103+23105+23106+23113+23104'
      )
      this.lab_area = q

      var p = this.handleValueModle0(
        23201,
        23202,
        23203,
        23204,
        23205,
        23206,
        23207,
        23208, 23209, 0,
        this.house_area,
        232,
        60,
        '2.3.2 配套辅助用房合计',
        '是指各学科仪器室、准备室、实验员室等配套的辅助用房个数合计',
        '个、m²',
        {
          code: 232,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '6'],
          id: 60,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, false],
          year: 2022
        },
        '23201+23202+23203+23204+23205+23206+23207+23208+23209'
      )
      this.house_area = p
    },
    handleValue(x, y, z, a) {
      var isExit = false
      var obj = {}
      obj.code = z.code
      obj.id = z.id
      obj.name = z.name
      obj.desc = z.desc
      obj.uom = z.uom
      obj.equipstandardopt = z.equipstandardopt
      obj.logic = z.logic
      obj.value1 = null
      obj.value2 = null
      obj.value3 = null
      obj.value4 = null
      obj.value5 = z.value5
      obj.value6 = null
      for (var i = 0; i < this.form.length; i++) {
        if (this.form[i].id == z.id) {
          this.form[i].value5 = z.value5
          isExit = true
          break
        }
      }
      if (!isExit) {
        this.form.push(obj)
      }
      console.log(this.form, 'this.form')

      var a = this.handleValueModle(
        22101,
        22102,
        0,
        0,
        0,
        0,
        0,
        0,
        0, 0,
        this.manager,
        221,
        32,
        '2.2.1 实验室管理人员合计',
        '是指从事小学科学、中学物理、化学、生物及其他学科（包括数学、地理、通用技术、劳动技术等）实验室管理工作的人员',
        '人',
        {
          code: 221,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 32,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '22101+22102=22103+22104+22105+22106+22111=22112+22113+22114+22115=22116+22117+22118=22119+22120+22121+22122'
      )
      this.manager = a

      var b = this.handleValueModle(
        23101,
        23102,
        23103,
        23105,
        23106,
        23113,
        23104,
        0, 0, 0,
        this.lab,
        231,
        52,
        '2.3.1 实验室合计',
        '是指用于小学科学、中学物理、化学、生物等学科学生实验用教室，不包括仪器室、准备室等配套的辅助用房',
        '个、m²',
        {
          code: 231,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '6'],
          id: 52,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, false],
          year: 2022
        },
        '23101+23102+23103+23105+23106+23113+23104'
      )
      this.lab = b

      var c = this.handleValueModle(
        23201,
        23202,
        23203,
        23204,
        23205,
        23206,
        23207,
        23208, 23209, 0,
        this.house,
        232,
        60,
        '2.3.2 配套辅助用房合计',
        '是指各学科仪器室、准备室、实验员室等配套的辅助用房个数合计',
        '个、m²',
        {
          code: 232,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '6'],
          id: 60,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, false],
          year: 2022
        },
        '23201+23202+23203+23204+23205+23206+23207+23208+23209'
      )
      this.house = c

      var d = this.handleValueModle(
        241,
        242,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.equip,
        24,
        80,
        '2.4 实验室仪器设备设施情况',
        ' ',
        '元 ',
        {
          code: 24,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 80,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '241+242'
      )
      this.equip = d

      var e = this.handleValueModle(
        24101,
        24102,
        24103,
        24104,
        24105,
        24106,
        24107,
        24114,
        0,
        0,
        this.yiqi_yuanzhi,
        241,
        81,
        '3.12.2 生均借阅量',
        '用于实验教学的演示仪器和分组仪器的当时购买价格合计',
        '元 ',
        {
          code: 241,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 81,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '24101+24102+24103+24104+24105+24106+24107+24114'
      )
      this.yiqi_yuanzhi = e

      var f = this.handleValueModle(
        24201,
        24203,
        24204,
        24205,
        24206,
        24207,
        24215,
        0,
        0,
        0,
        this.equip_yuanzhi,
        242,
        90,
        '2.4.2 设备设施原值合计',
        '指实验室、仪器室、准备室等室配备的实验桌、椅、演示台、准备台、仪器柜和水、电、光、气、安全等设施设备当时购买价格合计',
        '元 ',
        {
          code: 242,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 90,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '24201+24203+24204+24205+24206+24207+24215'
      )
      this.equip_yuanzhi = f

      var g = this.handleValueModle(
        24,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.yiqi_average,
        243,
        98,
        '2.4.3 仪器设备生均金额',
        '（仪器器材原值合计+设备设施原值合计）/学生数',
        '元 ',
        {
          code: 243,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 98,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '24/111'
      )
      this.yiqi_average = g

      var h = this.handleValueModle(
        24401,
        24402,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        this.lab_price,
        244,
        99,
        '2.4.4 实验室投入经费合计',
        '财政预算拨款+自筹及其他',
        '元 ',
        {
          code: 244,
          hisIdx: ['-1', '-1', '-1', '-1', '5', '-1'],
          id: 99,
          names: [
            '上年数值',
            '上年面积',
            '本年新增',
            '本年减少',
            '本年数值',
            '本年面积'
          ],
          optional: null,
          readOnly: [true, true, true, true, true, true],
          viewOnly: [true, true, true, true, false, true],
          year: 2022
        },
        '24401+24402'
      )
      this.lab_price = h

      if (this.form.length == this.data.length) {
        this.form.sort(this.compare('id'))
        this.toJson()
      }
    },
    handleValueModle0(
      code1,
      code2,
      code3,
      code4,
      code5,
      code6,
      code7,
      code8,
      code9, code10,
      value,
      code,
      id,
      name,
      desc,
      uom,
      equipstandardopt,
      logic
    ) {
      var isExit = false
      var pupil = this.arrayLookup(this.form, 'code', code1, 'value6')
      var junior = this.arrayLookup(this.form, 'code', code2, 'value6')
      var heigh = this.arrayLookup(this.form, 'code', code3, 'value6')
      var others = this.arrayLookup(this.form, 'code', code4, 'value6')
      var pupil1 = this.arrayLookup(this.form, 'code', code5, 'value6')
      var junior1 = this.arrayLookup(this.form, 'code', code6, 'value6')
      var heigh1 = this.arrayLookup(this.form, 'code', code7, 'value6')
      var heigh11 = this.arrayLookup(this.form, 'code', code8, 'value6')
      var pupil11 = this.arrayLookup(this.form, 'code', code9, 'value6')
      var junior11 = this.arrayLookup(this.form, 'code', code10, 'value6')
      value =
        Number(pupil) +
        Number(junior) +
        Number(heigh) +
        Number(others) +
        Number(pupil1) +
        Number(junior1) +
        Number(heigh1) +
        Number(heigh11) +
        Number(pupil11) +
        Number(junior11)
      if (value) {
        const obj1 = {}
        obj1.code = code
        obj1.id = id
        obj1.name = name
        obj1.desc = desc
        obj1.uom = uom
        obj1.equipstandardopt = equipstandardopt
        obj1.logic = logic
        obj1.value1 = null
        obj1.value2 = null
        obj1.value3 = null
        obj1.value4 = null
        obj1.value5 = null
        obj1.value6 = value
        for (var i = 0; i < this.form.length; i++) {
          if (this.form[i].id == id) {
            this.form[i].value6 = value
            isExit = true
            break
          }
        }
        if (!isExit) {
          this.form.push(obj1)
        }
      }
      return value
    },
    handleValueModle(
      code1,
      code2,
      code3,
      code4,
      code5,
      code6,
      code7,
      code8,
      code9,
      code10,
      value,
      code,
      id,
      name,
      desc,
      uom,
      equipstandardopt,
      logic
    ) {
      var isExit = false
      var pupil = this.arrayLookup(this.form, 'code', code1, 'value5')
      var junior = this.arrayLookup(this.form, 'code', code2, 'value5')
      var heigh = this.arrayLookup(this.form, 'code', code3, 'value5')
      var others = this.arrayLookup(this.form, 'code', code4, 'value5')
      var pupil1 = this.arrayLookup(this.form, 'code', code5, 'value5')
      var junior1 = this.arrayLookup(this.form, 'code', code6, 'value5')
      var heigh1 = this.arrayLookup(this.form, 'code', code7, 'value5')
      var others1 = this.arrayLookup(this.form, 'code', code8, 'value5')
      var pupil2 = this.arrayLookup(this.form, 'code', code9, 'value5')
      var junior2 = this.arrayLookup(this.form, 'code', code10, 'value5')
      value =
        Number(pupil) +
        Number(junior) +
        Number(heigh) +
        Number(others) +
        Number(pupil1) +
        Number(junior1) +
        Number(heigh1) +
        Number(others1) +
         Number(pupil2) +
        Number(junior2)
      if (code == 243) {
        var num2 = localStorage.getItem('111')
        var value1 = Number(pupil) / Number(num2)
        value = value1.toFixed(1)
      }
      if (
        code == 21 ||
        code == 22 ||
        code == 23 ||
        code == 233 ||
        code == 234 ||
        code == 25 ||
        code == 253 ||
        code == 254 ||
        code == 255 ||
        code == 256 || code == 257
      ) {
        value = null
      }
      if (
        value ||
        code == 21 ||
        code == 22 ||
        code == 23 ||
        code == 233 ||
        code == 234 ||
        code == 25 ||
        code == 253 ||
        code == 254 ||
        code == 255 ||
        code == 256 || code == 257
      ) {
        const obj1 = {}
        obj1.code = code
        obj1.id = id
        obj1.name = name
        obj1.desc = desc
        obj1.uom = uom
        obj1.equipstandardopt = equipstandardopt
        obj1.logic = logic
        obj1.value1 = null
        obj1.value2 = null
        obj1.value3 = null
        obj1.value4 = null
        obj1.value5 = value
        obj1.value6 = null
        for (var i = 0; i < this.form.length; i++) {
          if (this.form[i].id == id) {
            this.form[i].value5 = value
            isExit = true
            break
          }
        }
        if (!isExit) {
          this.form.push(obj1)
        }
      }
      return value
    },
    toJson() {
      for (let i = 0; i < this.form.length; i++) {
        const id = this.form[i].id
        const code = this.form[i].code
        const name = this.form[i].name
        const desc = this.form[i].desc
        const uom = this.form[i].uom
        const equipstandardopt = this.form[i].equipstandardopt
        const logic = this.form[i].logic
        const value1 = null
        const value2 = null
        const value3 = null
        const value4 = null
        const value5 = this.form[i].value5
        const value6 = this.form[i].value6
        this.jsonForm[id] = {
          code,
          name,
          desc,
          uom,
          equipstandardopt,
          logic,
          value1,
          value2,
          value3,
          value4,
          value5,
          value6
        }
      }
    },
    handleClear() {
      this.$confirm('此操作将永久删除该表格数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          localStorage.removeItem('form2')
          this.$emit('clear')
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    handleSave() {
      if (this.pushArr == true) {
        if (this.form.length < this.data.length) {
          this.$message.error('保存失败，请填写完整！')
        } else if ((this.form.length == this.data.length)) {
          this.toJson()
          const obj = {}
          obj.data = JSON.stringify(this.jsonForm)
          api.statistics.submit(obj).then((res) => {
            console.log(res)
            if (JSON.parse(localStorage.getItem('form2')) !== this.form) {
              this.$message.success('已保存成功！')
              localStorage.setItem('form2', JSON.stringify(this.form))
            } else if (JSON.parse(localStorage.getItem('form2')) == this.form) {
              this.$message.error('无修改数据！')
            } else {
              this.$message.success('已保存成功！')
              localStorage.setItem('form2', JSON.stringify(this.form))
            }
          })
        }
      } else {
        this.$message.error('保存失败，请仔细校验有取值逻辑的数值是否符合逻辑')
      }
    },
    handleName(v) {
      if (this.t != null) {
        clearTimeout(this.t)
      }
      this.t = setTimeout(() => {
        var reg = new RegExp('^[\u4e00-\u9fa5]|[a-zA-Z]+$')
        if (!reg.test(v)) {
          this.$message.error('仅支持输入中英文')
        }
      }, 800)
    },
    handleNumber(v) {
      if (this.t != null) {
        clearTimeout(this.t)
      }
      this.t = setTimeout(() => {
        var reg = new RegExp('^[0-9]*$')
        if (!reg.test(v.value5)) {
          this.$message.error('仅支持输入数字')
        } else if (v.code == 23402) {
          var num = this.arrayLookup(this.form, 'code', 231, 'value5')
          if (v.value5 > num) {
            this.$message.error(`请输入的数值小于等于${num}`)
            // this.pushArr = false
          }
        }
      }, 800)
    },
    handlePre() {
      this.$emit('pre')
    },
    handleNext() {
      if (this.form.length == this.data.length) {
        this.$emit('next')
      } else {
        this.$message.error('请先填写当前页面，才可进行下一步')
      }
    },
    handleOpen(v) {
      this.$alert(v, '查看指标解释', {
        confirmButtonText: '关闭',
        callback: (action) => {}
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.term1 {
  min-height: 720px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  &-top {
    display: inline-block;
    display: flex;
    justify-content: space-between;
    padding-bottom: 25px;
    border-bottom: 1px solid #d7d7d7;
    &-info {
      display: inline-block;
      .el-input {
        width: 62%;
      }
    }
    > span {
      padding: 0px 15px;
      border: 1px solid #d7d7d7;
      line-height: 34px;
      cursor: pointer;
      color: #8b8b8b;
    }
  }
  &-content {
    margin-top: 25px;
    .icon {
      cursor: pointer;
      position: absolute;
      right: 8px;
    }
    .logic {
      cursor: pointer;
    }
  }
}
.term1-top-info /deep/ .el-input__inner {
  height: 34px;
}
.text-center {
  display: block;
  text-align: center;
}
</style>
